import { useCertificateStore } from "@/stores";

export const CertificateSvgPortrait = () => {
  const { primaryColor, secondaryColor, thirdColor, isEditing } = useCertificateStore();

  return (
    <svg viewBox="0 0 634 812" x="0px" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" y="0px">
      <polygon fill={primaryColor} points="0,0 634,0 151.8,407.9 0,407.9" />
      <polygon fill={secondaryColor} points="634,0 151.8,407.9 634,812 	" />
      <polygon fill={thirdColor} points="0,812 634,812 151.8,407.9 0,407.9 	" />
      {isEditing && (
        <g>
          <path
            className="opacity-40"
            d="M630,8.6v794.8L158,407.9L630,8.6 M634,0L151.8,407.9L634,812V0L634,0z"
            fill="#fff"
          />
          <path
            className="opacity-40"
            d="M623.1,4L150.3,403.9H4V4H623.1 M634,0H0v407.9h151.8L634,0L634,0z"
            fill="#A8AFB3"
          />
          <path
            className="opacity-40"
            d="M150.3,411.9L623,808H4V411.9H150.3 M151.8,407.9H0V812h634L151.8,407.9L151.8,407.9z"
            fill="#E0E2E6"
          />
        </g>
      )}
    </svg>
  );
};
